import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

const inboxSearchSchema = z.object({
  inboxSection: z.string().optional(),
  messageId: z.string().optional(),
  readFilter: z.string().optional(),
});

export const Route = createFileRoute(
  '/_auth/_layout_with_full_navigation/inbox',
)({
  validateSearch: zodValidator(inboxSearchSchema),
});
